import { config } from "src/config/config";
import { ASSET_DETAILS_ACTIONS } from "src/actions/ui/asset_details";
import { AssetCategory } from "src/service/api_types";

// もともと型がなかったところに型を追加したので、any が含まれています。
type AssetDetailsState = {
  isPublic: boolean;
  category: AssetCategory;
  currentAsset: any;
};

const defaultState = {
  isPublic: true,
  category: AssetCategory.MARKET_PLACE,
  currentAsset: null,
};

export const assetDetailsReducer = (
  state: AssetDetailsState = defaultState,
  action: any
): AssetDetailsState => {
  switch (action.type) {
    case ASSET_DETAILS_ACTIONS.SET_CURRENT_ASSET: {
      if (config.APP_DEBUG) {
        console.log("ASSET_DETAILS_ACTIONS.SET_CURRENT_ASSET: ", action.data);
      }

      if (!action.data.asset) {
        return {
          ...state,
          isPublic: action.data.public,
          category: action.data.category,
        };
      } else {
        return {
          ...state,
          isPublic: action.data.public,
          category: action.data.category,
          currentAsset: action.data.asset,
        };
      }
    }
    default:
      return state;
  }
};
